import { UsersState } from '@redux/ducks/users';
import { GlobalState } from '@redux/ducks/global';
import { PartnerAdAccountsState } from '@redux/ducks/partnerAdAccounts/partnerAdAccounts';
import { PaymentMethod } from '@redux/ducks/paymentMethods';
import { TwoFactorConfigurationState } from '@redux/ducks/twoFactorConfiguration';
import { HistoryEventsState } from '@redux/ducks/historyEvents';
import { TrackerState } from './ducks/tracker/tracker';
import { UserPermissionsState } from './ducks/userPermissions/utils';

export interface RootState {
  tracker: TrackerState;
  global: GlobalState;
  users: UsersState;
  userPermissions: UserPermissionsState;
  partnerAdAccounts: PartnerAdAccountsState;
  paymentMethods: PaymentMethod;
  twoFactorConfiguration: TwoFactorConfigurationState;
  historyEvents: HistoryEventsState;
}

export enum TraceStatus {
  Info = 'info',
  Error = 'error',
}

export interface Trace {
  status: TraceStatus;
  message: string;
}

export type SelectorState<T> = (state: RootState) => T;

export interface DataError extends Error {
  data: { [key: string]: any };
}
